export default [
  {
    name: "Karl Johan",
    id: "6d4c358f-7ff0-4e73-93e7-3746103f3968",
  },
  {
    name: "Kantarellen",
    id: "949a1e25-06e8-490e-9b51-d93e22fb9065",
  },
  {
    name: "Fårtickan",
    id: "b8f5ff66-5d6f-42d9-8da0-bfffe9b5fce9",
  },
  {
    name: "Murklan",
    id: "43a6b707-88e1-40ce-9e0a-27d5f7768baa",
  },
]; /* .map(({ name, id }) => ({
  name,
  id,
  locationId: locations.campusUS.house473.id
}))
 */
